import type {ScheduleInterval} from './types';

import {chunkString} from '../../../string';
import {SCHEDULE_SLOT_DURATION} from './constants';
import {scheduleToBits} from './scheduleToBits';

export const getIntervalsFromSchedule = (schedule: string) => {
  const bitsArray: string[] = chunkString(schedule, 24).map(scheduleToBits);

  const result: ScheduleInterval[][] = [];

  bitsArray.forEach(bits => {
    let minutes = 0;

    const intervals: ScheduleInterval[] = [];

    let isLeftValue = true;

    for (let i = 0; i < bits.length; i++) {
      if (isLeftValue && bits[i] === '1') {
        isLeftValue = false;
        // @ts-expect-error: TODO: describy why
        intervals.push([minutes]);
      }

      if (!isLeftValue && bits[i] === '0') {
        isLeftValue = true;
        intervals[intervals.length - 1]!.push(minutes);
      }

      minutes = minutes + SCHEDULE_SLOT_DURATION;

      if (i === bits.length - 1 && !isLeftValue) {
        intervals[intervals.length - 1]!.push(minutes);
      }
    }

    result.push(intervals);
  });

  return result;
};
